import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Button, Modal } from "@mui/material";
import errorSign from "../../assets/images/errorSign.svg";
import "./style.scss";

export const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 340,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
};

const LogoutModal = ({ openDeleteModal, setOpenDeleteModal, handleDelete }) => {
  const cancelBtnRef = useRef(null);

  const handleClose = () => setOpenDeleteModal(false);

  const confirmDelete = () => {
    handleDelete();
    handleClose();
  };

  useEffect(() => {
    if (openDeleteModal) {
      setTimeout(() => {
        cancelBtnRef.current.focus();
      }, 500);
    }
  }, [openDeleteModal]);

  return (
    <div className="delte_modal_wrapper">
      <Modal open={openDeleteModal} className="delte_modal">
        <div role="none">
          <Box
            sx={modalBoxStyle}
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout_heading"
          >
            <div className="Modal_header">
              <h1 id="logout_heading">
                <img src={errorSign} alt="" aria-hidden="true" className="logoModalutDeleteImg" /> Logout
              </h1>
            </div>
            <div className="Modal_middle">
              <div className="inputdrapper">
                <p id="logout_descrip">Are you sure you want to Logout?</p>
              </div>
            </div>
            <div className="Modal_footer">
              <Box sx={{ display: "flex" }}>
                <Button
                  variant="outlined"
                  className="cancelBtn"
                  onClick={handleClose}
                  ref={cancelBtnRef}
                  aria-describedby ="logout_descrip"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="saveBtn"
                  onClick={confirmDelete}
                >
                  Ok
                </Button>
              </Box>
            </div>
          </Box>
        </div>
      </Modal>
    </div>
  );
};

LogoutModal.propTypes = {
  openDeleteModal: PropTypes.bool.isRequired,
  setOpenDeleteModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default LogoutModal;
